import { Injectable } from '@angular/core';

@Injectable()
export class CoresService {

  private colors = [
    '#003568', // azul
    '#EB323C', // vermelho
    '#FE9A47', // laranga
    '#00BAAD', // azul baby
    '#834BD3', // roxo
    '#2c3e50',
    '#d35400',
    '#f1c40f',
    '#1abc9c',
  ];

  constructor() { }

  get() {
    return this.colors;
  }
}
